// /home/szymon/kreator2/frontend/src/components/AdminDashboard.js
// v10.1.0 – Dodano link do Ustawień AI

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom"; // Import Link
import { QrCode } from "lucide-react"; // Import ikony QR
import OrdersPanel from "./OrdersPanel";
import FontsPanel from "./FontsPanel";
import TemplatesPanel from "./TemplatesPanel";
import RebusesPanel from "./RebusesPanel";
import MailSettingsPanel from "./MailSettingsPanel";
import MailTemplatesPanel from "./MailTemplatesPanel";
import AdminAiSettings from "./AdminAiSettings"; // Importujemy nowy komponent ustawień AI
import DatabasePanel from "./DatabasePanel";
import ProjectsPanel from "./ProjectsPanel";
import MailTriggersPanel from "./MailTriggersPanel";

// NOWE:
import StatusesPanel from "./StatusesPanel";
import AdminMockupsPanel from "./admin/mockups/AdminMockupsPanel"; // NOWY IMPORT
import ApiKeysPanel from "./admin/ApiKeysPanel";
import BlissaroPanel from "./admin/BlissaroPanel"; // NOWY IMPORT

export default function AdminDashboard({ onLogout, backendUrl }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("orders");

  // Odczyt parametru ?tab= z URL, ustawienie aktywnej zakładki
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    const validTabs = [
      "templates",
      "fonts",
      "orders",
      "rebuses",
      "mailsettings",
      "mailtemplates",
      "ai", // Przywracamy 'ai' do validTabs
      "database",
      "projects",
      "mailtriggers",
      // NOWA ZAKŁADKA:
      "statuses",
      "mockups", // DODAJEMY MOCKUPS DO VALIDTABS
      "api",
      "blissaro", // DODAJEMY BLISSARO
    ];
    if (validTabs.includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  // Klik w bocznym menu
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    navigate(`/admin?tab=${tabName}`);
  };

  // Wylogowanie
  const handleLogout = async () => {
    try {
      await fetch(`${backendUrl}/admin/logout`, {
        method: "POST",
        credentials: "include",
      });
      onLogout();
      navigate("/admin/login");
    } catch (err) {
      console.error("Błąd wylogowania:", err);
    }
  };

  // Render główny panel
  const renderMainContent = () => {
    switch (activeTab) {
      case "orders":
        return <OrdersPanel backendUrl={backendUrl} />;
      case "fonts":
        return <FontsPanel backendUrl={backendUrl} />;
      case "templates":
        return <TemplatesPanel backendUrl={backendUrl} />;
      case "rebuses":
        return <RebusesPanel backendUrl={backendUrl} />;
      case "mailsettings":
        return <MailSettingsPanel backendUrl={backendUrl} />;
      case "mailtemplates":
        return <MailTemplatesPanel backendUrl={backendUrl} />;
      case "ai": // Przywracamy case 'ai', renderując nowy komponent
        return <AdminAiSettings backendUrl={backendUrl} />;
      case "database":
        return <DatabasePanel backendUrl={backendUrl} />;
      case "projects":
        return <ProjectsPanel backendUrl={backendUrl} />;
      case "mailtriggers":
        return <MailTriggersPanel backendUrl={backendUrl} />;
      // NOWA opcja "statuses"
      case "statuses":
        return <StatusesPanel backendUrl={backendUrl} />;
      case "mockups": // NOWY CASE DLA MOCKUPS
        return <AdminMockupsPanel backendUrl={backendUrl} />;
      case "api":
        return <ApiKeysPanel backendUrl={backendUrl} />;
      case "blissaro": // NOWY CASE DLA BLISSARO
        return <BlissaroPanel backendUrl={backendUrl} />;
      default:
        return <OrdersPanel backendUrl={backendUrl} />;
    }
  };

  return (
    <div className="admin-dashboard-container">
      <div className="admin-dashboard-sidebar">
        <div className="sidebar-logo">
          <h2>ADMIN</h2>
        </div>
        <ul className="sidebar-menu">
          <li
            className={activeTab === "orders" ? "active" : ""}
            onClick={() => handleTabClick("orders")}
          >
            Zamówienia
          </li>
          <li
            className={activeTab === "fonts" ? "active" : ""}
            onClick={() => handleTabClick("fonts")}
          >
            Czcionki
          </li>
          <li
            className={activeTab === "templates" ? "active" : ""}
            onClick={() => handleTabClick("templates")}
          >
            Szablony
          </li>
          <li
            className={activeTab === "rebuses" ? "active" : ""}
            onClick={() => handleTabClick("rebuses")}
          >
            Rebusy
          </li>
          <li
            className={activeTab === "mailsettings" ? "active" : ""}
            onClick={() => handleTabClick("mailsettings")}
          >
            Mail Settings
          </li>
          <li
            className={activeTab === "mailtemplates" ? "active" : ""}
            onClick={() => handleTabClick("mailtemplates")}
          >
            Edytor Maili
          </li>
          {/* Przywracamy zakładkę AI, usuwając osobny Link */}
          <li
            className={activeTab === "ai" ? "active" : ""}
            onClick={() => handleTabClick("ai")}
          >
            Ustawienia AI {/* Zmieniamy nazwę na bardziej opisową */}
          </li>
          <li
            className={activeTab === "database" ? "active" : ""}
            onClick={() => handleTabClick("database")}
          >
            Baza danych
          </li>
          <li
            className={activeTab === "projects" ? "active" : ""}
            onClick={() => handleTabClick("projects")}
          >
            Projects
          </li>
          <li
            className={activeTab === "mailtriggers" ? "active" : ""}
            onClick={() => handleTabClick("mailtriggers")}
          >
            Trigger mail
          </li>
          {/* NOWY przycisk do zakładki Statusy */}
          <li
            className={activeTab === "statuses" ? "active" : ""}
            onClick={() => handleTabClick("statuses")}
          >
            Statusy
          </li>
          {/* NOWY PRZYCISK ZAKŁADKI MOCKUPY */}
          <li
            className={activeTab === "mockups" ? "active" : ""}
            onClick={() => handleTabClick("mockups")}
          >
            Mockupy
          </li>
          <li
            className={activeTab === "api" ? "active" : ""}
            onClick={() => handleTabClick("api")}
          >
            Klucze API
          </li>
          <li
            className={activeTab === "blissaro" ? "active" : ""}
            onClick={() => handleTabClick("blissaro")}
          >
            <QrCode size={16} style={{ display: "inline", marginRight: "8px" }} />
            Blissaro QR
          </li>
        </ul>
        <button className="logout-button" onClick={handleLogout}>
          Wyloguj
        </button>
      </div>

      <div className="admin-dashboard-main">{renderMainContent()}</div>
    </div>
  );
}
